export default {
  role: 'https://ethics.socioeconomics.com/role',
};
